import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GenerateDianContentPdfService {
  constructor() {}

  private formatCurrency(value: number): string {
    return value?.toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 2,
    });
  }

  createHeaderInvoice(
    invoiceCode: string,
    invoiceType: string,
    electronicInvoice: string,
    qrUrl: string,
  ): any {
    return {
      columns: [
        {
          width: '*',
          stack: [
            {
              text: `${invoiceType} de venta: ${electronicInvoice}`,
              style: 'title',
              margin: [0, 0, 0, 8],
            },
            { text: invoiceType, style: 'titleBold', margin: [0, 0, 0, 12] },
            { text: invoiceCode, style: 'invoiceCode', margin: [0, 0, 0, 0] },
          ],
          alignment: 'left',
        },
        {
          width: 'auto',
          stack: [
            { qr: qrUrl, fit: 90, alignment: 'right', margin: [0, 0, 0, 0] },
          ],
          alignment: 'right',
          margin: [12, 0, 0, 0],
        },
      ],
      margin: [0, 40, 40, 0],
    };
  }

  async createEmitterInfo(emitter: any, logoObj?: any): Promise<any> {
    if (logoObj) {
      return {
        columns: [
          {
            image: logoObj.image,
            width: logoObj.width,
            height: logoObj.height,
            alignment: 'left',
            margin: [0, 0, 16, 0],
          },
          {
            width: '*',
            stack: [
              { text: emitter.name, style: 'emmiterBold', alignment: 'left' },
              {
                text: [
                  { text: 'NIT: ', bold: true },
                  { text: emitter.nit, style: 'emmiter' },
                ],
                alignment: 'left',
              },
              {
                text: [
                  { text: 'Dirección: ', bold: true },
                  { text: emitter.address, style: 'emmiter' },
                ],
                alignment: 'left',
              },
              {
                text: [
                  {
                    text:
                      emitter.tributary_regime !== ''
                        ? 'Regimen Tributario: '
                        : '',
                    bold: true,
                  },
                  { text: emitter.responsibility_code, style: 'emmiter' },
                ],
                alignment: 'left',
              },
              {
                text: [
                  {
                    text:
                      emitter.responsibility_code !== ''
                        ? 'Codigo de Responsabilidad Fiscal: '
                        : '',
                    bold: true,
                  },
                  { text: emitter.responsibility_code, style: 'emmiter' },
                ],
                alignment: 'left',
              },
            ],
            alignment: 'left',
            margin: [36, 0, 0, 0],
          },
        ],
        margin: [0, 0, 0, 8],
        gap: [12, 12, 12, 12],
      };
    } else {
      return {
        columns: [
          {
            width: '*',
            stack: [
              { text: emitter.name, style: 'emmiterBold', alignment: 'left' },
              {
                text: [
                  { text: 'NIT: ', bold: true },
                  { text: emitter.nit, style: 'emmiter' },
                ],
                alignment: 'left',
              },
              {
                text: [
                  { text: 'Dirección: ', bold: true },
                  { text: emitter.adress, style: 'emmiter' },
                ],
                alignment: 'left',
              },
              {
                text: [
                  {
                    text:
                      emitter.tributary_regime !== ''
                        ? 'Regimen Tributario: '
                        : '',
                    bold: true,
                  },
                  { text: emitter.tributary_regime, style: 'emmiter' },
                ],
                alignment: 'left',
              },
              {
                text: [
                  {
                    text:
                      emitter.responsibility_code !== ''
                        ? 'Responsabilidad: '
                        : '',
                    bold: true,
                  },
                  { text: emitter.responsibility_code, style: 'emmiter' },
                ],
                alignment: 'left',
              },
            ],
            alignment: 'left',
            margin: [12, 0, 0, 0],
          },
        ],
        margin: [0, 0, 0, 8],
      };
    }
  }
  createCufeInfo(dian: any): any {
    return {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          stack: [
            {
              text: [
                {
                  text: dian.cufe !== '' ? 'CUFE: ' : '',
                  bold: true,
                  fontSize: 10,
                },
                { text: dian.cufe, style: 'cufe' },
              ],
              alignment: 'right',
            },
            {
              text: [
                {
                  text: dian.resolution !== '' ? 'Resolución DIAN: ' : '',
                  bold: true,
                  fontSize: 10,
                },
                { text: dian.resolution, style: 'cufe' },
              ],
              alignment: 'right',
            },
            {
              text: [
                {
                  text: dian.range !== '' ? 'Rango Autorizado: ' : '',
                  bold: true,
                  fontSize: 10,
                },
                { text: dian.range, style: 'cufe' },
              ],
              alignment: 'right',
            },
          ],
          alignment: 'right',
        },
      ],
      margin: [0, 0, 0, 8],
    };
  }

  createClientAndEmission(
    client: any,
    emission: any,
    invoiceType: string,
  ): any {
    return {
      columns: [
        {
          width: '45%',
          columns: [
            {
              width: 6,
              canvas: [
                { type: 'rect', x: 0, y: 0, w: 3, h: 80, color: '#0000' },
              ],
            },
            {
              width: '*',
              stack: [
                { text: 'DATOS DEL CLIENTE', style: 'sectionHeader' },
                { text: client.name, style: 'client' },
                { text: `NIT/Cédula: ${client.id}`, style: 'client' },
                { text: client.address, style: 'client' },
                { text: `Correo: ${client.email}`, style: 'client' },
              ],
              alignment: 'left',
              margin: [5, 5, 0, 0],
            },
          ],
        },
        {
          width: '55%',
          alignment: 'right',
          stack: [
            {
              canvas: [
                {
                  type: 'rect',
                  x: -10,
                  y: 0,
                  w: 270,
                  h: 100,
                  r: 12,
                  color: '#d9d9d9',
                },
              ],
            },
            {
              table: {
                widths: ['40%', '60%'],
                alignment: 'right',
                body: [
                  [
                    {
                      stack: [
                        {
                          text: invoiceType,
                          style: 'sectionHeader',
                          margin: [0, 4, 0, 0],
                        },
                        {
                          text: emission.code,
                          style: 'emission',
                          margin: [0, 0, 0, 8],
                        },
                        {
                          text: 'Forma de pago',
                          style: 'sectionHeader',
                          margin: [0, 8, 0, 0],
                        },
                        {
                          text: emission.payment_form,
                          style: 'emission',
                          margin: [0, 0, 0, 8],
                        },
                      ],
                      border: [false, false, false, false],
                      margin: [12, 8, 0, 8],
                      alignment: 'left',
                    },
                    {
                      stack: [
                        {
                          text: 'Fecha y Hora de emisión',
                          style: 'sectionHeader',
                          margin: [0, 4, 0, 0],
                        },
                        {
                          text: emission.emission_date,
                          style: 'emission',
                          margin: [0, 0, 0, 8],
                        },
                        {
                          text: 'Fecha de vencimiento',
                          style: 'sectionHeader',
                          margin: [0, 8, 0, 0],
                        },
                        {
                          text: emission.due_date,
                          style: 'emission',
                          margin: [0, 0, 0, 8],
                        },
                      ],
                      border: [false, false, false, false],
                      margin: [8, 8, 8, 8],
                      alignment: 'left',
                    },
                  ],
                ],
              },
              layout: {
                fillColor: () => null,
                hLineWidth: () => 0,
                vLineWidth: () => 0,
              },
              margin: [0, -95, 0, 0],
            },
          ],
          margin: [12, 0, 0, 12],
        },
      ],
      margin: [0, 0, 0, 8],
    };
  }

  createDetailTable(items: any[]): any {
    return {
      table: {
        widths: ['7%', '14%', '20%', '10%', '15%', '6%', '14%', '14%'],
        headerRows: 1,
        body: [
          [
            {
              text: 'Ítem',
              style: 'tableHeader',
              border: [false, false, false, false],
              noWrap: true,
              margin: [0, 10, 0, 10],
              alignment: 'left',
            },
            {
              text: 'Codigo',
              style: 'tableHeader',
              border: [false, false, false, false],
              margin: [0, 10, 0, 10],
              alignment: 'left',
            },
            {
              text: 'Descripción',
              style: 'tableHeader',
              border: [false, false, false, false],
              margin: [0, 10, 0, 10],
              alignment: 'left',
            },
            {
              text: 'Cantidad',
              style: 'tableHeader',
              border: [false, false, false, false],
              margin: [0, 10, 0, 10],
              alignment: 'left',
            },
            {
              text: 'Valor Unitario',
              style: 'tableHeader',
              border: [false, false, false, false],
              margin: [0, 10, 0, 10],
              alignment: 'left',
            },
            {
              text: 'IVA',
              style: 'tableHeader',
              border: [false, false, false, false],
              margin: [0, 10, 0, 10],
              alignment: 'left',
            },
            {
              text: 'Valor IVA',
              style: 'tableHeader',
              border: [false, false, false, false],
              margin: [0, 10, 0, 10],
              alignment: 'left',
            },
            {
              text: 'Subtotal',
              style: 'tableHeader',
              border: [false, false, false, false],
              margin: [0, 10, 0, 10],
              alignment: 'left',
            },
          ],
          ...items.map((row) => [
            {
              text: row.item,
              style: 'tableCell',
              border: [false, false, false, true],
              noWrap: true,
              margin: [0, 13, 0, 13],
              alignment: 'left',
            },
            {
              text: row.code,
              style: 'tableCell',
              border: [false, false, false, true],
              margin: [0, 13, 0, 13],
              alignment: 'left',
            },
            {
              text: row.description,
              style: 'tableCell',
              border: [false, false, false, true],
              margin: [0, 13, 0, 13],
              alignment: 'left',
            },
            {
              text: row.quantity,
              style: 'tableCell',
              border: [false, false, false, true],
              margin: [0, 13, 0, 13],
              alignment: 'left',
            },
            {
              text: row.unitPrice,
              style: 'tableCell',
              border: [false, false, false, true],
              margin: [0, 13, 0, 13],
              alignment: 'left',
            },
            {
              text: row.iva,
              style: 'tableCell',
              border: [false, false, false, true],
              margin: [0, 13, 0, 13],
              alignment: 'left',
            },
            {
              text: row.ivaValue,
              style: 'tableCell',
              border: [false, false, false, true],
              margin: [0, 13, 0, 13],
              alignment: 'left',
            },
            {
              text: row.subtotal,
              style: 'tableCell',
              border: [false, false, false, true],
              margin: [0, 13, 0, 13],
              alignment: 'left',
            },
          ]),
        ],
      },
      layout: {
        fillColor: (rowIndex: number) => (rowIndex === 0 ? '#e0e0e0' : null),
        lineColor: function () {
          return '#929295';
        },
      },
      margin: [0, 8, 0, 8],
    };
  }

  createObservationsAndTotals(obs: string, totals: any): any {
    return {
      columns: [
        {
          width: '50%',
          stack: [
            { text: 'Observaciones:', style: 'section-header' },
            { text: obs || 'N/A', style: 'observations' },
          ],
          alignment: 'left',
          margin: [0, 0, 0, 8],
        },
        {
          width: '50%',
          stack: [this.createTotals(totals)],
          alignment: 'right',
        },
      ],
      margin: [0, 0, 0, 8],
    };
  }

  createLegalFooter(texto: string, cufe?: string): any {
    let finalText = texto;
    if (cufe) {
      finalText += ' ' + cufe;
    }
    return {
      table: {
        widths: ['100%'],
        body: [
          [
            {
              text: finalText,
              style: 'footer',
              fillColor: '#e0e0e0',
              border: [false, false, false, false],
              margin: [8, 4, 8, 4],
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [0, 8, 0, 0],
    };
  }

  createTotalsRow(label: string, value: string, highlighted = false): any[] {
    const verticalMargin = highlighted ? 4 : 2;
    return [
      {
        text: label,
        alignment: 'right',
        border: [false, false, false, false],
        margin: [0, verticalMargin, 8, verticalMargin],
        noWrap: true,
        bold: true,
      },
      {
        text: value,
        alignment: 'left',
        border: [false, false, false, false],
        margin: [8, verticalMargin, 0, verticalMargin],
        noWrap: true,
      },
    ];
  }

  createTotals(totals: any): any {
    // Credit notes store negative amounts, and the item table above already prints
    // them in absolute values, so the totals block does the same: what marks the
    // document as a credit is its type, not a column of minus signs. The discount is
    // the one row printed negative, on every document type, because it reads as the
    // subtraction that takes the gross subtotal down to the taxable base.
    const discount = Math.abs(Number(totals.discount) || 0);
    const subtotal = Math.abs(Number(totals.subtotal) || 0);
    const grossSubtotal =
      Math.abs(Number(totals.grossSubtotal) || 0) || subtotal + discount;
    const body: any[] = [];

    // Gross subtotal and discount are only printed when the document carries one, so
    // documents without a discount render exactly as they did before.
    if (discount >= 0.005) {
      body.push(
        this.createTotalsRow(
          'Subtotal bruto',
          this.formatCurrency(grossSubtotal),
        ),
        this.createTotalsRow('Descuento total', this.formatCurrency(-discount)),
      );
    }

    body.push(
      this.createTotalsRow(
        'Subtotal antes de\u00A0impuestos',
        this.formatCurrency(subtotal),
      ),
      this.createTotalsRow(
        'IVA (19%)',
        this.formatCurrency(Math.abs(Number(totals.iva) || 0)),
      ),
      this.createTotalsRow(
        'Valor total neto',
        this.formatCurrency(Math.abs(Number(totals.netValue) || 0)),
      ),
      this.createTotalsRow(
        'Total a pagar',
        this.formatCurrency(Math.abs(Number(totals.total) || 0)),
        true,
      ),
    );

    const highlightedRowIndex = body.length - 1;
    return {
      table: {
        widths: ['55%', '45%'],
        body,
      },
      layout: {
        fillColor: function (rowIndex: number) {
          if (rowIndex === highlightedRowIndex) return '#d9d9d9';
          return null;
        },
        hLineWidth: () => 0,
        vLineWidth: () => 0,
      },
      margin: [0, 12, 8, 0],
    };
  }
}
